import React from "react";
import MenuModel from "../../Models/MenuModel";

function MenuCircle({
  element,
  name,
  props,
  IMG_URl,
}: {
  element: MenuModel;
  name: keyof MenuModel;
  props: any;
  IMG_URl: string;
}) {
  const isActive = element.id === props.selectedMenu;
  const hasSelectedMenu = !!props.selectedMenu;

  return (
    <div
      key={element.id}
      className={`relative flex flex-col items-center gap-2 cursor-pointer transition-all duration-300 ${
        isActive ? "menu-active" : ""
      }`}
      onClick={() =>
        element.id !== props.selectedMenu ? props.onClickMenu(element.id) : null
      }
    >
      <div
        className={`relative transition-all duration-300 ${
          isActive ? "scale-110" : "hover:scale-105"
        } ${
          hasSelectedMenu && !isActive ? "opacity-70 hover:opacity-100" : ""
        }`}
      >
        <div
          className={`absolute inset-0 rounded-full transition-all duration-300 ${
            isActive
              ? "bg-primary/20 shadow-lg shadow-primary/30"
              : "bg-transparent"
          }`}
        />
        <img
          alt={element.name_en}
          src={`${IMG_URl}${element.image}`}
          className={`max-w-28  w-28 h-28 rounded-full object-cover ${
            props.selectedMenu ? "max-w-16 !w-16 h-16 max-h-16" : ""
          }`}
        />
      </div>
      <p
        className={`text-center font-semibold transition-all duration-300 ${
          isActive
            ? "text-sm md:text-base text-onPrimary font-bold"
            : hasSelectedMenu
            ? "text-xs md:text-sm text-onBackground/70"
            : "text-xs md:text-sm text-onBackground"
        }`}
      >
        {element[name]}
      </p>
    </div>
  );
}

export default MenuCircle;
